import createDataContext from "./createDataContext";
import axios from 'axios'


const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {...state, token:action.payload}
        case 'LOGOUT':
          return {...state, token: null}

        case 'REG':
          return {...state, token:action.payload}
      default:
        return state;
    }
  };

  const login = dispatch => async ({email, password}) => {
    await axios.post('https://vigrant-vitale.herokuapp.com/api/login', {email, password})
    .then(r => {
        console.log(r.data.token)
        localStorage.setItem('token', r.data.token);
        dispatch({
          type:'LOGIN',
          payload: r.data.token
        })
    })
  }

  const logout = dispatch => () =>{
      localStorage.removeItem('token')
      dispatch({
        type:'LOGOUT'
      })
  }

  const reg = dispatch => async({name, email, password, password_confrim}) => {
    await axios.post('https://vigrant-vitale.herokuapp.com/api/adminreg', {name, email, password, password_confrim})
    .then(r => {
      localStorage.setItem('token', r.data.token);
      dispatch({
        type: 'REG',
        payload: r.data.token
      })
    })
  }


  export const { Provider, Context } = createDataContext(
    authReducer,
    { login, logout, reg },
    { token: null, errorMessage: "", error: "", isLoading: false }
  );